import { createContext } from "react";
import type { SelectedDashboard } from "../DashboardProvider.types";

const SelectedDashboardContext = createContext<SelectedDashboard | undefined>(undefined);
SelectedDashboardContext.displayName = "SelectedDashboardContext";

export default SelectedDashboardContext;
